export const stopVideosPlaying = () => {
    const videos = document.querySelectorAll('video')
    videos && videos.forEach((video) => {
        const videoSrc = video.getAttribute('src')
        videoSrc && video.setAttribute('src', videoSrc)
    })
}

export const setCSSVariable = (variable: string, value:string) => document.documentElement.style.setProperty(variable, value)